"use client";

import { c as _c } from "react/compiler-runtime";
import { useDashboardRouter as useRouter } from "@/hooks/useDashboardRouter";
import { useEffect, useMemo, useRef } from "react";
import { useActiveGithubOrgForUser, useConnectedGithubOrgs } from "@/hooks/useConnectedGithubOrgs";
import WelcomeDialog from "@/components/WelcomeDialog";
import { MainPaneLoader } from "@/components/MainPaneLoader";
import { Dv360FloodlightAppLpConversion } from "@/components/marketing/Dv360FloodlightAppLpConversion";
import { useDashboardSearchParams as useSearchParams } from "@/hooks/useDashboardNavigation";
import { withInstanceBasePath } from "@/lib/named-org";
import { codesmithDesktopBridge } from "@/lib/codesmithSurface";
export default function Index() {
  const $ = _c(17);
  const router = useRouter();
  const nullableSearchParams = useSearchParams();
  let t0;
  if ($[0] !== nullableSearchParams) {
    t0 = nullableSearchParams ?? new URLSearchParams();
    $[0] = nullableSearchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const searchParams = t0;
  const {
    activeNamedOrg,
    codesmithEnabled
  } = useActiveGithubOrgForUser();
  const {
    connectedGithubOrgs
  } = useConnectedGithubOrgs();
  const hasNavigated = useRef(false);
  let t1;
  if ($[2] !== activeNamedOrg || $[3] !== codesmithEnabled || $[4] !== connectedGithubOrgs?.instance_slug || $[5] !== router || $[6] !== searchParams) {
    t1 = () => {
      if (activeNamedOrg && !hasNavigated.current) {
        hasNavigated.current = true;
        const params = new URLSearchParams(searchParams.toString());
        const landing = params.get("landing");
        params.delete("landing");
        const queryString = params.toString();
        const isMobile = window.matchMedia("(max-width: 767px)").matches;
        const basePath = codesmithDesktopBridge() || codesmithEnabled && landing === "codesmith" ? `/${activeNamedOrg?.orgName}/sessions` : codesmithEnabled && isMobile ? `/${activeNamedOrg?.orgName}/sessions/new` : `/${activeNamedOrg?.orgName}/home`;
        const newPath = `${basePath}${queryString ? `?${queryString}` : ""}`;
        router.replace(withInstanceBasePath(newPath, connectedGithubOrgs?.instance_slug), undefined, {
          shallow: true
        });
      }
    };
    $[2] = activeNamedOrg;
    $[3] = codesmithEnabled;
    $[4] = connectedGithubOrgs?.instance_slug;
    $[5] = router;
    $[6] = searchParams;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const t2 = activeNamedOrg?.orgName;
  const t3 = connectedGithubOrgs?.instance_slug;
  let t4;
  if ($[8] !== codesmithEnabled || $[9] !== router || $[10] !== searchParams || $[11] !== t2 || $[12] !== t3) {
    t4 = [t2, codesmithEnabled, t3, router, searchParams];
    $[8] = codesmithEnabled;
    $[9] = router;
    $[10] = searchParams;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  useEffect(t1, t4);
  let t5;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Dv360FloodlightAppLpConversion />;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== connectedGithubOrgs?.installations.length) {
    t6 = <>{t5}{connectedGithubOrgs?.installations.length ? <MainPaneLoader /> : <WelcomeDialog />}</>;
    $[15] = connectedGithubOrgs?.installations.length;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}